module.exports = __webpack_public_path__ + "img/unlock-blue-rectangle-gif.921d5245.gif";